/* unplugin-vue-components disabled */const { computed } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-28eff26a"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "ctrl-wrap" };
const _hoisted_2 = { class: "ctrl-img-wrap" };
const _hoisted_3 = { class: "top-img" };
const _hoisted_4 = { class: "center-img" };
const _hoisted_5 = { class: "bottom-img" };
const _hoisted_6 = { class: "ctrl-btn-wrap" };
const _hoisted_7 = { class: "speed-text" };
const up_png_1 = tslib_1.__importDefault(require("@/assets/CtrlBtn/up.png"));
const down_png_1 = tslib_1.__importDefault(require("@/assets/CtrlBtn/down.png"));
const left_png_1 = tslib_1.__importDefault(require("@/assets/CtrlBtn/left.png"));
const right_png_1 = tslib_1.__importDefault(require("@/assets/CtrlBtn/right.png"));
const speed_png_1 = tslib_1.__importDefault(require("@/assets/CtrlBtn/speed.png"));
const up_active_png_1 = tslib_1.__importDefault(require("@/assets/CtrlBtn/up_active.png"));
const down_active_png_1 = tslib_1.__importDefault(require("@/assets/CtrlBtn/down_active.png"));
const left_active_png_1 = tslib_1.__importDefault(require("@/assets/CtrlBtn/left_active.png"));
const right_active_png_1 = tslib_1.__importDefault(require("@/assets/CtrlBtn/right_active.png"));
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CtrlBtn',
    props: {
        stopEvt: {
            type: Boolean,
            default: false
        }
    },
    emits: ['moveUpTouch', 'moveUpEnd', 'moveDownTouch', 'moveDownEnd', 'rotatLeftTouch', 'rotatLeftEnd', 'rotatRightTouch', 'rotatRightEnd', 'changeSpeed', 'stopEvt'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const SPEED = [5, 20, 50];
        const curSpeedIndex = (0, vue_3.ref)(1);
        const curSpeed = computed(() => SPEED[curSpeedIndex.value]);
        const emit = __emit;
        const isUpActive = (0, vue_3.ref)(false);
        const isDownActive = (0, vue_3.ref)(false);
        const isLeftActive = (0, vue_3.ref)(false);
        const isRightActive = (0, vue_3.ref)(false);
        function emitEvent(evtStr) {
            if (props.stopEvt === true) {
                emit('stopEvt');
                return;
            }
            switch (evtStr) {
                case 'moveUpTouch':
                    isUpActive.value = true;
                    break;
                case 'moveUpEnd':
                    isUpActive.value = false;
                    break;
                case 'moveDownTouch':
                    isDownActive.value = true;
                    break;
                case 'moveDownEnd':
                    isDownActive.value = false;
                    break;
                case 'rotatLeftTouch':
                    isLeftActive.value = true;
                    break;
                case 'rotatLeftEnd':
                    isLeftActive.value = false;
                    break;
                case 'rotatRightTouch':
                    isRightActive.value = true;
                    break;
                case 'rotatRightEnd':
                    isRightActive.value = false;
                    break;
            }
            emit(evtStr);
        }
        function changeSpeed() {
            ++curSpeedIndex.value;
            if (curSpeedIndex.value > 2) {
                curSpeedIndex.value = 0;
            }
        }
        __expose({
            curSpeed,
            changeSpeed,
        });
        return (_ctx, _cache) => {
            const _component_el_image = (0, vue_2.resolveComponent)("el-image");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_image, {
                            src: (0, vue_2.unref)(up_png_1.default),
                            class: "outside-horizontal-img"
                        }, null, 8, ["src"]), [
                            [vue_2.vShow, !isUpActive.value]
                        ]),
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_image, {
                            src: (0, vue_2.unref)(up_active_png_1.default),
                            class: "outside-horizontal-img"
                        }, null, 8, ["src"]), [
                            [vue_2.vShow, isUpActive.value]
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_image, {
                            src: (0, vue_2.unref)(left_png_1.default),
                            class: "outside-vertical-img"
                        }, null, 8, ["src"]), [
                            [vue_2.vShow, !isLeftActive.value]
                        ]),
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_image, {
                            src: (0, vue_2.unref)(left_active_png_1.default),
                            class: "outside-vertical-img"
                        }, null, 8, ["src"]), [
                            [vue_2.vShow, isLeftActive.value]
                        ]),
                        (0, vue_2.createVNode)(_component_el_image, {
                            src: (0, vue_2.unref)(speed_png_1.default),
                            class: "speed-img"
                        }, null, 8, ["src"]),
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_image, {
                            src: (0, vue_2.unref)(right_png_1.default),
                            class: "outside-vertical-img"
                        }, null, 8, ["src"]), [
                            [vue_2.vShow, !isRightActive.value]
                        ]),
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_image, {
                            src: (0, vue_2.unref)(right_active_png_1.default),
                            class: "outside-vertical-img"
                        }, null, 8, ["src"]), [
                            [vue_2.vShow, isRightActive.value]
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_image, {
                            src: (0, vue_2.unref)(down_png_1.default),
                            class: "outside-horizontal-img"
                        }, null, 8, ["src"]), [
                            [vue_2.vShow, !isDownActive.value]
                        ]),
                        (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_image, {
                            src: (0, vue_2.unref)(down_active_png_1.default),
                            class: "outside-horizontal-img"
                        }, null, 8, ["src"]), [
                            [vue_2.vShow, isDownActive.value]
                        ])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_6, [
                    (0, vue_2.createElementVNode)("div", {
                        class: "up-btn",
                        onTouchstart: _cache[0] || (_cache[0] = ($event) => (emitEvent('moveUpTouch'))),
                        onTouchend: _cache[1] || (_cache[1] = ($event) => (emitEvent('moveUpEnd')))
                    }, null, 32),
                    (0, vue_2.createElementVNode)("div", {
                        class: "left-btn",
                        onTouchstart: _cache[2] || (_cache[2] = ($event) => (emitEvent('rotatLeftTouch'))),
                        onTouchend: _cache[3] || (_cache[3] = ($event) => (emitEvent('rotatLeftEnd')))
                    }, null, 32),
                    (0, vue_2.createElementVNode)("div", {
                        class: "speed-btn",
                        onTouchstart: _cache[4] || (_cache[4] = ($event) => (emitEvent('changeSpeed')))
                    }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(curSpeed)) + "%", 1)
                    ], 32),
                    (0, vue_2.createElementVNode)("div", {
                        class: "right-btn",
                        onTouchstart: _cache[5] || (_cache[5] = ($event) => (emitEvent('rotatRightTouch'))),
                        onTouchend: _cache[6] || (_cache[6] = ($event) => (emitEvent('rotatRightEnd')))
                    }, null, 32),
                    (0, vue_2.createElementVNode)("div", {
                        class: "down-btn",
                        onTouchstart: _cache[7] || (_cache[7] = ($event) => (emitEvent('moveDownTouch'))),
                        onTouchend: _cache[8] || (_cache[8] = ($event) => (emitEvent('moveDownEnd')))
                    }, null, 32)
                ])
            ]));
        };
    }
});
